import React, { Component } from "react";
import TimelineContainer from "../../containers/Timeline";
import TabBody from "../../../../../_sharedComponents/TabBody";
import EditPropertyTopNav from "../../components/EditPropertyTopNav";
import PageWrap from "../../../../../_sharedComponents/PageWrap";

interface IProps {}

class Timeline extends Component<IProps> {
    render() {
        return (
            <PageWrap>
                <EditPropertyTopNav />

                <TabBody>
                    <TimelineContainer />
                </TabBody>
            </PageWrap>
        );
    }
}

export default Timeline;
